const groupsrow = (state = [], action) => {
  switch (action.type) {
    case "GROUPSROW":
      return action.groupsrow;

    default:
      return state;
  }
};

export default groupsrow;
